"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This file is based on https://github.com/steemit/condenser/blob/master/src/app/utils/SanitizeConfig.js
 */

var ow_1 = require("ow");

var _sanitize = require("sanitize-html");

var Log_1 = require("../../../Log");

var StaticConfig_1 = require("../StaticConfig");

var TagTransformingSanitizer =
/*#__PURE__*/
function () {
  function TagTransformingSanitizer(options, localization) {
    _classCallCheck(this, TagTransformingSanitizer);

    this.sanitizationErrors = [];
    TagTransformingSanitizer.Options.validate(options);
    this.localization = localization;
    this.options = options;
  }

  _createClass(TagTransformingSanitizer, [{
    key: "sanitize",
    value: function sanitize(text) {
      return _sanitize(text, this.generateSanitizeConfig());
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      return this.sanitizationErrors;
    }
  }, {
    key: "generateSanitizeConfig",
    value: function generateSanitizeConfig() {
      var _this = this;

      return {
        allowedTags: StaticConfig_1.StaticConfig.sanitization.allowedTags,
        // SEE https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        allowedAttributes: {
          // "src" MUST pass a whitelist (below)
          iframe: ["src", "width", "height", "frameborder", "allowfullscreen", "webkitallowfullscreen", "mozallowfullscreen"],
          // class attribute is strictly whitelisted (below)
          // and title is only set in the case of a phishing warning
          div: ["class", "title"],
          // style is subject to attack, filtering more below
          td: ["style"],
          img: ["src", "alt"],
          // title is only set in the case of an external link warning
          a: ["href", "rel", "title"]
        },
        allowedSchemes: ["http", "https", "steem"],
        transformTags: {
          iframe: function iframe(tagName, attribs) {
            var srcAtty = attribs.src;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = StaticConfig_1.StaticConfig.sanitization.iframeWhitelist[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.re.test(srcAtty)) {
                  var src = typeof item.fn === "function" ? item.fn(srcAtty) : srcAtty;

                  if (!src) {
                    break;
                  }

                  var iframeToBeReturned = {
                    tagName: "iframe",
                    attribs: {
                      frameborder: "0",
                      allowfullscreen: "allowfullscreen",
                      // deprecated but required for vimeo : https://vimeo.com/forums/help/topic:278181
                      webkitallowfullscreen: "webkitallowfullscreen",
                      mozallowfullscreen: "mozallowfullscreen",
                      src: src,
                      width: _this.options.iframeWidth + "",
                      height: _this.options.iframeHeight + ""
                    }
                  };
                  return iframeToBeReturned;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            Log_1.Log.log().warn('Blocked, did not match iframe "src" white list urls:', tagName, attribs);

            _this.sanitizationErrors.push("Invalid iframe URL: " + srcAtty);

            var retTag = {
              tagName: "div",
              text: "(Unsupported ".concat(srcAtty, ")"),
              attribs: {}
            };
            return retTag;
          },
          img: function img(tagName, attribs) {
            if (_this.options.noImage) {
              var retTagOnImagesNotAllowed = {
                tagName: "div",
                text: _this.localization.noImage,
                attribs: {}
              };
              return retTagOnImagesNotAllowed;
            } // See https://github.com/punkave/sanitize-html/issues/117


            var src = attribs.src,
                alt = attribs.alt;

            if (!/^(https?:)?\/\//i.test(src)) {
              Log_1.Log.log().warn("Blocked, image tag src does not appear to be a url", tagName, attribs);

              _this.sanitizationErrors.push("An image in this post did not save properly.");

              var retTagOnNoUrl = {
                tagName: "img",
                attribs: {
                  src: "brokenimg.jpg"
                }
              };
              return retTagOnNoUrl;
            }

            var atts = {};
            atts.src = src.replace(/^http:\/\//i, "//"); // replace http:// with // to force https when needed

            if (alt && alt !== "") {
              atts.alt = alt;
            }

            var retTag = {
              tagName: tagName,
              attribs: atts
            };
            return retTag;
          },
          div: function div(tagName, attribs) {
            var attys = {};
            var classWhitelist = ["pull-right", "pull-left", "text-justify", "text-rtl", "text-center", "text-right", "videoWrapper", "phishy"];
            var validClass = classWhitelist.find(function (e) {
              return attribs.class === e;
            });

            if (validClass) {
              attys.class = validClass;
            }

            if (validClass === "phishy" && attribs.title === _this.localization.phishingWarning) {
              attys.title = attribs.title;
            }

            var retTag = {
              tagName: tagName,
              attribs: attys
            };
            return retTag;
          },
          td: function td(tagName, attribs) {
            var attys = {};

            if (attribs.style === "text-align:right") {
              attys.style = "text-align:right";
            }

            var retTag = {
              tagName: tagName,
              attribs: attys
            };
            return retTag;
          },
          a: function a(tagName, attribs) {
            var href = attribs.href;

            if (!href) {
              href = "#";
            }

            href = href.trim();
            var attys = {
              href: href
            }; // If it's not a (relative or absolute) steemit URL...

            if (!_this.options.isLinkSafeFn(href)) {
              // attys.target = '_blank' // pending iframe impl https://mathiasbynens.github.io/rel-noopener/
              attys.rel = _this.options.addNofollowToLinks ? "nofollow noopener" : "noopener";
              attys.title = _this.localization.phishingWarning;
            }

            var retTag = {
              tagName: tagName,
              attribs: attys
            };
            return retTag;
          }
        }
      };
    }
  }]);

  return TagTransformingSanitizer;
}();

exports.TagTransformingSanitizer = TagTransformingSanitizer;

(function (TagTransformingSanitizer) {
  var Options;

  (function (Options) {
    function validate(o) {
      ow_1.default(o.iframeWidth, "TagTransformingSanitizer.Options.iframeWidth", ow_1.default.number.integer.positive);
      ow_1.default(o.iframeHeight, "TagTransformingSanitizer.Options.iframeHeight", ow_1.default.number.integer.positive);
      ow_1.default(o.addNofollowToLinks, "TagTransformingSanitizer.Options.addNofollowToLinks", ow_1.default.boolean);
      ow_1.default(o.noImage, "TagTransformingSanitizer.Options.noImage", ow_1.default.boolean);
      ow_1.default(o.isLinkSafeFn, "TagTransformingSanitizer.Options.isLinkSafeFn", ow_1.default.function);
    }

    Options.validate = validate;
  })(Options = TagTransformingSanitizer.Options || (TagTransformingSanitizer.Options = {}));
})(TagTransformingSanitizer = exports.TagTransformingSanitizer || (exports.TagTransformingSanitizer = {}));